export const smtpCredentialsTestType = {
  connection: 'connection',
  tls: 'tls',
  authentication: 'authentication',
} as const;
